/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from 'react';
import styles from './home.module.scss';
import Layout from '../layouts/User';
import {
  Button,
  Card,
  Col,
  Divider,
  Input,
  Radio,
  Row,
  Spin,
  Tag,
  Typography,
  Image,
  Select,
} from 'antd';
import { BASE_URL, DEFAULT_PRODUCT_URL } from '../config';
import axios from 'axios';
import { useSelector } from 'react-redux';
import {
  useNavigate,
  Link,
  useSearchParams,
  useParams,
} from 'react-router-dom';
import {
  CloseOutlined,
  LoadingOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons';
import InfiniteScroll from 'react-infinite-scroll-component';
import { convertPrice } from '../utils/display';
import Bannerbar from '../components/TopNavbar/bannerbar';

const { Text, Paragraph } = Typography;
const { Search } = Input;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const Promotion: React.FC = () => {
  const user = useSelector((state: any) => state.user);
  const currentLocationLatLong = useSelector(
    (state: any) => state.currentLocation
  );
  const currentAddress = useSelector((state: any) => state.currentAddress);
  const [currentPageLocation, setCurrentPageLocation] = useState<any>({
    lat: 0,
    long: 0,
  });
  const [isDateText, setDateText] = useState<any>(true);
  const navigate = useNavigate();
  const [dueDate, setdueDate] = useState<any>();
  const [isFetchedShop, setIsFetchedShop] = useState(false);
  const [shopProducts, setShopProducts] = useState<any>([]);
  const [hasProducts, setHasProducts] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);
  const [skip, setSkip] = useState<number>(1);
  const [postalCode, setPostalCode] = useState<string>('');
  const [postalCodeQuery, setPostalCodeQuery] = useState<string>('');
  const [disable, setDisable] = useState<boolean>(true);
  const [hidden, setHidden] = useState<boolean>(true);
  const [currentUser, setCurrentUser] = useState<any>({});
  const [promotionList, setPromotionList] = useState<any>([]);
  const [disabledPromotionList, setDisabledPromotionList] = useState<any>(true);
  const [textTitleProduct, setTextTitleProduct] =
    useState<any>('สินค้าโปรโมชั่น');
  const [selectedPromotionId, setSelectedPromotionId] = useState<any>();
  const [isPromotionFocus, setIsPromotionFocus] = useState<boolean>(false);
  const [hiddenFilter, setHiddenFilter] = useState<boolean>(false);
  const { id } = useParams();

  const limit = 10;

  const getPostalCode = async (address: any) => {
    for (let i = 0; i < address[0].address_components.length; i++) {
      for (let b = 0; b < address[0].address_components[i].types.length; b++) {
        if (address[0].address_components[i].types[b] === 'postal_code') {
          setPostalCode(address[0].address_components[i].short_name);
          break;
        }
      }
    }

    setDisable(false);
  };

  const getPromotionName = async () => {
    const { data } = await axios.get('/promotions/getActivePromotion');
    const promotions = [];
    const promotionName = data.filter(
      (promotion: any) => promotion.id === Number(id)
    );
    console.log('promotionName.....', promotionName);
    setTextTitleProduct(`สินค้าโปรโมชั่น ${promotionName[0].PRSellerName}`);
    for (const promotion of data) {
      promotions.push({ value: promotion.id, label: promotion.PRSellerName });
    }
    setPromotionList(promotions);
  };

  // const onChatClick = () => {
  //   // console.log(`go to chat ${LINE_ID}`);

  //   const url = `https://line.me/R/ti/p/${LINE_ID}`;
  //   window.open(url, "_blank");
  // };

  const onPrivacyNotice = () => {
    navigate('/PrivacyNotice');
  };
  const clone = async () => {
    localStorage.setItem('DataFixTime', '');
    setDateText(false);
  };

  const days = () => {
    const date1 = new Date('09/1/2022');
    const date2 = new Date();
    let difference = date1.getTime() - date2.getTime();
    let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
    console.log(TotalDays);

    setdueDate(TotalDays);
  };

  const getProductRecommend = async () => {
    if (loading) return;
    if (currentPageLocation.lat === 0) return;
    setLoading(true);
    const url = `${BASE_URL}/shops/product/recommend?lat=${
      currentPageLocation.lat
    }&long=${
      currentPageLocation.long
    }&postal_code=${postalCodeQuery}&skip=${skip}&limit=${limit}&user=${
      currentUser._id ? currentUser._id : ''
    }&promo=${selectedPromotionId ? selectedPromotionId : ''}`;
    const response = await axios.get(url);
    let shops = response.data.shops;

    if (shops.length < limit) {
      setHasProducts(false);
    }
    setIsFetchedShop(true);

    const promotionProducts = await findPromotionTag(shops);

    for (const shop of shops) {
      shop.products = shop.products.map((productItem: any) => ({
        ...productItem,
        ...promotionProducts.find(
          (pp: any) =>
            pp.sellerCode === shop.code &&
            pp.productCode === productItem.product.code
        ),
      }));
    }

    if (currentUser._id) {
      const shopMembers = await findShopMember(shops);
      shops = shops.map((shopItem: any) => ({
        ...shopItem,
        ...shopMembers.find((sm: any) => sm.shopId === shopItem._id),
      }));
    }

    setShopProducts([...shopProducts, ...shops]);
    setSkip(skip + 1);
    setLoading(false);
  };

  const findPromotionTag = async (shops: any) => {
    const url = '/promotions/sellerProducts';
    const prepareSellerProducts = [];

    for (const shop of shops) {
      for (const productItem of shop.products) {
        prepareSellerProducts.push({
          sellerCode: shop.code,
          productCode: productItem.product.code,
        });
      }
    }

    const { data } = await axios.post(url, {
      sellerProducts: prepareSellerProducts,
    });
    return data;
  };

  const findShopMember = async (shops: any) => {
    const url = `${BASE_URL}/shop-buyer/shop-buyer-member-multiple/${currentUser._id}`;
    const prepareShops = shops.map((item: any) => item._id);

    const { data } = await axios.post(url, { shops: prepareShops });
    return data.shops;
  };

  const searchProduct = async (value: any) => {
    if (value) {
      navigate(
        `/search?keyword=${value}&lat=${currentPageLocation.lat}&long=${
          currentPageLocation.long
        }&postal_code=${postalCode}&user=${
          currentUser._id ? currentUser._id : ''
        }&promo=${selectedPromotionId ? selectedPromotionId : ''}`
      );
    }
  };

  const changeByArea = async (value: string) => {
    setShopProducts([]);
    setSkip(1);
    setHasProducts(true);

    if (value === 'area') {
      setPostalCodeQuery(postalCode);
    } else if (value === 'all') {
      setPostalCodeQuery('');
    }
  };

  const onSelectedPromotion = async (value: any) => {
    setSkip(1);
    setShopProducts([]);
    console.log('select......', value);
    setSelectedPromotionId(value);
  };

  const changeByProductFilter = async (value: string) => {
    if (value === 'recommend') {
      setSkip(1);
      setShopProducts([]);
      setDisabledPromotionList(true);
      setIsPromotionFocus(false);
      setTextTitleProduct('สินค้าแนะนำ');
      setSelectedPromotionId(undefined);
    } else if (value === 'promotion') {
      setDisabledPromotionList(false);
      setIsPromotionFocus(true);
      setTextTitleProduct('สินค้าโปรโมชั่น');
    }
  };

  const addDefaultImage = async (ev: any) => {
    if (!ev.target.errored) {
      ev.target.errored = true;
      ev.target.src = DEFAULT_PRODUCT_URL;
    }
  };

  useEffect(() => {
    if (currentLocationLatLong.lat && !isFetchedShop) {
      setCurrentPageLocation(currentLocationLatLong);
    }
  }, [currentLocationLatLong]);

  useEffect(() => {
    if (id) {
      setSelectedPromotionId(id);
      setHiddenFilter(true);
    }
    if (currentPageLocation.lat) {
      getProductRecommend();
    }
  }, [
    currentPageLocation,
    postalCodeQuery,
    selectedPromotionId,
    textTitleProduct,
  ]);

  useEffect(() => {
    if (currentAddress.results) {
      getPostalCode(currentAddress.results);
      getPromotionName();
    }
  }, [currentAddress]);

  useEffect(() => {
    if (postalCode) {
      setHidden(false);
    }
  }, [postalCode]);

  useEffect(() => {
    days();
    if (user._id) {
      setCurrentUser(user);
    }
  }, [user]);

  const ProductList = () => {
    return (
      <>
        <Row>
          <Col span={24}>
            <InfiniteScroll
              dataLength={shopProducts.length}
              next={getProductRecommend}
              hasMore={hasProducts}
              loader={
                <div
                  className={styles.textCenter}
                  style={{
                    marginTop: '90px',
                    marginBottom: '90px',
                    fontSize: '14px',
                  }}
                >
                  <Spin indicator={antIcon} />
                  &nbsp;&nbsp;กำลังโหลดรายการสินค้า
                </div>
              }
              className={styles.infiniteScrollWrapper}
              style={{ overflow: 'unset' }}
            >
              <Row gutter={10}>
                {shopProducts.map((shop: any) => {
                  return (
                    <React.Fragment key={shop._id}>
                      {shop.products.map((productItem: any) => {
                        return (
                          <Col xs={12} sm={6} lg={4} key={productItem._id}>
                            <Link
                              to={`/shops/product-detail/?id=${productItem._id}`}
                            >
                              <Card
                                hoverable
                                className={styles.productItem}
                                bodyStyle={{
                                  padding: '7px 0 0 0',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'baseline',
                                }}
                                cover={
                                  <img
                                    alt='product'
                                    src={
                                      productItem.product.files.length
                                        ? productItem.product.files[0]
                                        : DEFAULT_PRODUCT_URL
                                    }
                                    onError={async (e) => {
                                      await addDefaultImage(e);
                                    }}
                                  />
                                }
                              >
                                <Paragraph
                                  ellipsis={{ rows: 3, symbol: '...' }}
                                  style={{
                                    height: '66px',
                                    marginBottom: 0,
                                    padding: '0 10px',
                                  }}
                                >
                                  {productItem.product.productName}
                                </Paragraph>

                                {productItem.hasPromotion ? (
                                  <Tag
                                    color='#d4380d'
                                    style={{
                                      fontSize: '10px',
                                      lineHeight: '18px',
                                      marginLeft: '10px',
                                    }}
                                  >
                                    ร่วมโปรโมชั่น
                                  </Tag>
                                ) : (
                                  <div style={{ height: '20px' }}>&nbsp;</div>
                                )}

                                <div className={styles.antTextSecondary}>
                                  <strong>
                                    ฿&nbsp;
                                    {shop.isMember ? (
                                      <>
                                        {convertPrice(productItem.memberPrice)}
                                        <div
                                          className={styles.productPriceBefore}
                                        >
                                          {convertPrice(productItem.price)}
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        {convertPrice(productItem.price)}
                                        <div style={{ height: '14px' }}>
                                          &nbsp;
                                        </div>
                                      </>
                                    )}
                                  </strong>
                                </div>

                                <div className={styles.productItemFooter}>
                                  <Paragraph
                                    ellipsis={{ rows: 1, symbol: '...' }}
                                    className={styles.shopName}
                                  >
                                    <span>ขายโดย:</span> {shop.name}
                                  </Paragraph>
                                  <div className={styles.shopDistance}>
                                    <span>
                                      {shop.distCalculated.toFixed(1)} กม.
                                    </span>
                                  </div>
                                </div>
                              </Card>
                            </Link>
                          </Col>
                        );
                      })}
                    </React.Fragment>
                  );
                })}
              </Row>
            </InfiniteScroll>
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      <Bannerbar />
      <Layout>
        <div className={styles.header}>
          <Text strong className={`${styles.buttonLink} ${styles.active}`}>
            หน้าแรก
          </Text>
          <Link to='/promotions' className={styles.buttonLink}>
            <Text>โปรโมชั่นสำหรับคุณ</Text>
          </Link>
        </div>
        <Divider className={styles.divider} />
        <Row>
          <Col xs={12} lg={24}>
            <div className={styles.filterText}>ค้นหาสินค้า</div>
          </Col>

          <Col xs={12} md={0}>
            <Link to='/product-categories'>
              <Button
                className={styles.catText}
                shape='round'
                icon={<UnorderedListOutlined />}
                size='small'
              >
                หมวดหมู่
              </Button>
            </Link>
          </Col>

          <Col xs={24} lg={24}>
            <Search
              className={styles.searchInput}
              placeholder='ค้นหาสินค้าที่คุณต้องการ'
              onSearch={searchProduct}
              enterButton
              disabled={disable}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={24} sm={5}>
            <div
              className={`${styles.filterText} ${styles.recommend}`}
              style={{ display: disable === true ? 'none' : 'flex' }}
            >
              {textTitleProduct}
            </div>
          </Col>

          <Col xs={24} sm={19}>
            <div
              className={`${styles.filterText} ${styles.recommend} ${styles.option}`}
              style={{ paddingBottom: '10px' }}
              hidden={hiddenFilter}
            >
              <div>ตัวกรอง</div>
              <Radio.Group
                onChange={(e) => changeByProductFilter(e.target.value)}
                defaultValue='recommend'
                buttonStyle='solid'
              >
                <Radio.Button
                  value='recommend'
                  className={`${styles.recommend} ${styles.radioButton}`}
                >
                  <span className={styles.radioText}>สินค้าแนะนำ</span>
                </Radio.Button>
                <Radio.Button
                  value='promotion'
                  className={`${styles.recommend} ${styles.radioButton}`}
                >
                  <span className={styles.radioText}>โปรโมชั่น</span>
                </Radio.Button>
              </Radio.Group>
              <Select
                showAction={['focus']}
                autoFocus={isPromotionFocus}
                className={`${styles.recommend} ${styles.selectPromotion}`}
                placeholder='กรุณาเลือกโปรโมชั่น'
                onChange={onSelectedPromotion}
                value={selectedPromotionId}
                options={promotionList}
                disabled={disabledPromotionList}
              ></Select>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={5}></Col>

          <Col xs={19} sm={19}>
            <div
              className={`${styles.filterText} ${styles.recommend} ${styles.option}`}
              style={{ display: hidden === true ? 'none' : 'flex' }}
            >
              <div>แสดงสินค้า</div>
              <Radio.Group
                onChange={(e) => changeByArea(e.target.value)}
                defaultValue='all'
                buttonStyle='solid'
                disabled={disable}
              >
                <Radio.Button
                  value='all'
                  className={`${styles.recommend} ${styles.radioButton}`}
                >
                  <span className={styles.radioText}>ทั้งหมด</span>
                </Radio.Button>
                <Radio.Button
                  value='area'
                  className={`${styles.recommend} ${styles.radioButton}`}
                >
                  <span className={styles.radioText}>อยู่ในพื้นที่จัดส่ง</span>
                </Radio.Button>
              </Radio.Group>
            </div>
          </Col>
        </Row>
        {ProductList()}

        {dueDate > 0 ? (
          <>
            {isDateText ? (
              <div
                style={{
                  position: 'fixed',
                  zIndex: 99,
                  bottom: 10,
                  right: 10,
                }}
              >
                <Card style={{ width: 300, backgroundColor: '#bebebe' }}>
                  <Card
                    style={{
                      position: 'fixed',
                      zIndex: 99,
                      bottom: 267,
                      right: 18,
                      height: '21px',
                      width: '21px',
                    }}
                  ></Card>
                  <div
                    style={{
                      position: 'fixed',
                      zIndex: 99,
                      bottom: 265,
                      right: 20,
                    }}
                  >
                    <a onClick={clone}>
                      <CloseOutlined
                        style={{ color: 'black', fontSize: '16px' }}
                      />
                    </a>
                  </div>

                  <div>
                    &nbsp;&nbsp;&nbsp;&nbsp;ท่านสามารถขอยกเลิกความยินยอมในการประมวลผลข้อมูลส่วนบุลคล
                    ที่เว็บไซต์เก็บรวบรวมไว้
                    ก่อนวันที่พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.2562
                    ใช้บังคับ โดยติดต่อผู้ควบคุมข้อมูลส่วนบุคคลที่ระบุไว้ใน
                    &nbsp;
                    <a onClick={onPrivacyNotice}>นโยบายความเป็นส่วนตัว</a>{' '}
                    <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;สำหรับข้อมูลส่วนบุคคลประเภทบุคคล
                    ประเภทอื่นๆ ที่เอสซีจี(บริษัทปูนซีเมนต์ไทย จำกัด (มหาชน)
                    และบริษัทในกลุ่มเอสซีจีตามงบการเงินรวม) ได้เก็บรวบรวมไว้
                    โปรดติดต่อ data.privacy@scg.com
                  </div>
                </Card>
              </div>
            ) : (
              <div></div>
            )}
          </>
        ) : (
          <div></div>
        )}
      </Layout>
    </>
  );
};
export default Promotion;
